<div
  class="bn-central-widget"
  [ngClass]="{
    'bn-central-widget--collapsed': isWidgetCollapsed,
    'bn-central-widget--visible': uploadFileStatuses.length,
    'bn-central-widget--no-progress-bar': centralWidgetNoProgressBar,
    'bn-central-widget--over-side-panel': contentService.isSidePanelOpen(),
  }">
  <div
    class="bn-central-widget__header p-2 d-flex align-items-center"
    (click)="toggleWidget()">
    <fa-icon
      class="bn-central-widget__type-icon"
      icon="file-arrow-up" />
    <span class="title flex-grow-1">File Upload</span>
    <small
      ><a
        class="me-2 link-secondary"
        size="sm"
        (click)="onClearFinishedClick($event)"
        >Clear completed</a
      ></small
    >
    <fa-icon
      class="bn-central-widget__collapse-icon"
      size="sm"
      title="Close"
      [icon]="['fas', isWidgetCollapsed ? 'chevron-up' : 'chevron-down']" />
  </div>
  <div class="bn-central-widget__content p-2">
    <ul class="bn-central-widget__items-list">
      <!--      <li-->
      <!--        class="bn-central-widget&#45;&#45;item__total d-flex position-relative"-->
      <!--        (click)="toggleListView()">-->
      <!--        <div class="bn-central-widget&#45;&#45;item&#45;&#45;icon">-->
      <!--          <fa-icon icon="file-lines"></fa-icon>-->
      <!--        </div>-->
      <!--        <div class="bn-central-widget&#45;&#45;item&#45;&#45;filename flex-grow-1">-->
      <!--          {{ uploadFileStatuses.length }} files-->
      <!--        </div>-->
      <!--        <div class="bn-central-widget&#45;&#45;item__total&#45;&#45;stats"></div>-->
      <!--      </li>-->
      @if (isFileListVisible) {
        @for (uploadFileStatus of uploadFileStatuses; track uploadFileStatus.id) {
          @let progress = uploadFileStatus.progress || 0;

          <li
            class="bn-central-widget__item d-flex position-relative"
            containerClass="tooltip--html"
            placement="bottom left"
            [ngClass]="{
              'bn-central-widget__item--completed': uploadFileStatus.state === 'complete' || progress >= 100,
            }"
            (mouseenter)="onToggleProgressView($index, uploadFileStatus.state, false)"
            (mouseleave)="onToggleProgressView($index, uploadFileStatus.state)">
            <div class="bn-central-widget__item__icon">
              <fa-icon icon="file-lines" />
            </div>
            <div
              class="bn-central-widget__item__filename flex-grow-1"
              [title]="uploadFileStatus.filename">
              {{ uploadFileStatus.filename }}
            </div>
            @if (showPercentage.get($index) === false) {
              <div class="bn-central-widget__item__file-progress me-4">
                {{ (uploadFileStatus.bytesUploaded || 0 | formatByte: 2 : uploadFileStatus.fileSize?.i).value }} / {{ uploadFileStatus.fileSize?.formatted }}
              </div>
            } @else if (progress > 0) {
              <div
                class="bn-central-widget__item__percentage me-4"
                [style.transition-duration]="transitionDuration + 'ms'">
                {{ progress }} %
              </div>
            }

            <div class="bn-central-widget__item__file-progress">
              @if (progress >= 100) {
                <div
                  class="bn-central-widget__item__status-icon"
                  [ngClass]="{ 'bn-central-widget__item__status-icon--visible': progress >= 100 }">
                  <fa-icon
                    icon="check"
                    size="sm" />
                </div>
              } @else {
                <bn-web-ui-progress-circle
                  contextType="light-success"
                  [progress]="progress"
                  [transitionDuration]="transitionDuration / 2 + 'ms'" />
              }
            </div>
            <div
              class="bn-central-widget__item__dismiss"
              title="Dismiss"
              (click)="onDismissClick(uploadFileStatus.id)">
              <fa-icon
                icon="xmark"
                title="Dismiss" />
            </div>
          </li>
        }
      }
    </ul>
  </div>
</div>
<div
  class="bn-central-widget__progress-bar"
  [ngClass]="{
    'bn-central-widget__progress-bar--visible': showProgressBar,
  }"
  (transitionend)="progressBarTransitionEnd($event)">
  <span
    class="bn-central-widget__progress-bar__sum_percentage"
    [ngStyle]="{
      'max-width': (uploadSummary.percentDone.value || 0) + '%',
      'transition-duration': +(uploadSummary.percentDone.value || 0) >= 100 ? '0ms' : transitionDuration + 'ms',
    }"
    (transitionend)="progressBarTrackTransitionEnd($event)"></span>
</div>
